import format from 'date-fns/format'
import parse from 'date-fns/parse'

export default function formattedTime(event) {
  if (!event) return

  if (event.allDay) return 'All Day'

  if (event.multiDay) {
    return `<b>MultiDay Event:</b><br/>Starts: ${format(
      parse(event.originalStart, "yyyy-MM-dd'T'HH:mm:ssX", new Date()),
      '<b>h:mm aa</b>, ddd, MMM DD, YYYY'
    )
      .replace(/#/g, '&nbsp;')
      .replace(/:00/g, '')}<br>Ends: ${format(
      parse(event.end, "yyyy-MM-dd'T'HH:mm:ssX", new Date()),
      '<b>h:mm aa</b>, ddd, MM DD, YYYY'
    )
      .replace(/#/g, '&nbsp;')
      .replace(/:00/g, '')}`
  }

  const startTime = parse(event.start, "yyyy-MM-dd'T'HH:mm:ssX", new Date())
  const endTime = parse(event.end, "yyyy-MM-dd'T'HH:mm:ssX", new Date())
  const startHour = startTime.getHours()

  if (
    startTime.getTime() === endTime.getTime() &&
    (startHour >= 23 || startHour < 3)
  ) {
    return 'TBD'
  }

  let time = `${format(startTime, '<b>h:mm aa</b>').replace(/:00/g, '')}`

  if (startTime.getTime() === endTime.getTime()) {
    time += ''
  } else if (event.endTimeUndetermined) {
    time += `${format(endTime).replace(/:00/g, '')}`
  } else {
    time += ` - ${format(endTime, '<b>h:mm aa</b>')
      .replace(/#/g, '&nbsp;')
      .replace(/:00/g, '')}`
  }

  return time
}
